/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdFrequencyCapDto } from "./AdFrequencyCapDto";
export type UpdateAdDto = {
  /**
   * 광고명
   */
  name?: string;
  /**
   * 광고 배지 표시 여부
   */
  showAdBadge?: boolean;
  /**
   * 클릭 보상 지급 여부 (탐색 상단 광고)
   */
  clickRewardEnabled?: boolean;
  /**
   * 광고 콘텐츠 (타입별 다른 구조, 전체 교체)
   */
  content?: Record<string, any>;
  /**
   * 프리퀀시 캡 설정 (null로 설정 시 제거)
   */
  frequencyCap?: AdFrequencyCapDto | null;
  /**
   * 상태
   */
  status?: UpdateAdDto.status;
};
export namespace UpdateAdDto {
  /**
   * 상태
   */
  export enum status {
    DRAFT = "DRAFT",
    ACTIVE = "ACTIVE",
    PAUSED = "PAUSED",
    COMPLETED = "COMPLETED",
  }
}
